import { useQuery } from "@tanstack/react-query";
import { customFetch } from "@workspace/api-client-react";
import { Loader2, Rocket } from "lucide-react";
import { BrandTile } from "@/components/BrandTile";
import { PLAN_DEFS, formatBRL, priceCents } from "@/lib/plans";

// `byPlan` só vem pra conta dev (peu burguer) — ver /api/subscribers-count.
interface Resp {
  count: number;
  byPlan?: Record<string, number>;
}

const nf = (n: number) => n.toLocaleString("pt-BR");

export default function Assinaturas() {
  const { data, isLoading, isError } = useQuery({
    queryKey: ["assinaturas-count"],
    queryFn: () => customFetch<Resp>("/api/subscribers-count"),
  });

  const byPlan = data?.byPlan;
  // (Profissional × 49,90) + (Ultra × 197), pelo preço mensal de cada plano
  // (Pedro, 27/10/2026).
  const valorCents = byPlan
    ? (byPlan["profissional"] ?? 0) * priceCents("profissional", "monthly") +
      (byPlan["ultra"] ?? 0) * priceCents("ultra", "monthly")
    : 0;

  return (
    <div className="min-h-[100svh] w-full flex flex-col items-center justify-center bg-muted/30 p-6">
      <div className="flex flex-col items-center gap-6 text-center">
        <BrandTile size="lg" className="shadow-md" />
        <p className="text-xs sm:text-sm uppercase tracking-widest text-muted-foreground font-medium">
          Assinantes do Venda no Zap
        </p>
        {isLoading ? (
          <Loader2 className="w-10 h-10 animate-spin text-primary" />
        ) : isError ? (
          <p className="text-destructive text-lg">Não foi possível carregar.</p>
        ) : byPlan ? (
          <>
            <div className="flex items-start justify-center gap-10 sm:gap-16">
              <div className="flex flex-col items-center gap-1">
                <span className="text-[11px] sm:text-xs uppercase tracking-widest text-muted-foreground font-medium">
                  {PLAN_DEFS.profissional.name}
                </span>
                <span className="text-6xl sm:text-7xl font-bold tabular-nums text-foreground">
                  {nf(byPlan["profissional"] ?? 0)}
                </span>
              </div>
              <div className="flex flex-col items-center gap-1">
                <span className="text-[11px] sm:text-xs uppercase tracking-widest text-muted-foreground font-medium inline-flex items-center gap-1">
                  <Rocket className="w-3 h-3" /> {PLAN_DEFS.ultra.name}
                </span>
                <span className="text-6xl sm:text-7xl font-bold tabular-nums text-primary">
                  {nf(byPlan["ultra"] ?? 0)}
                </span>
              </div>
            </div>
            <div className="flex flex-col items-center gap-1">
              <p className="text-base sm:text-xl text-muted-foreground tabular-nums">Total {nf(data?.count ?? 0)}</p>
              <p className="text-base sm:text-xl text-muted-foreground font-bold tabular-nums">{formatBRL(valorCents)}</p>
            </div>
          </>
        ) : (
          <p className="text-7xl sm:text-8xl font-bold tabular-nums text-foreground">
            {nf(data?.count ?? 0)}
          </p>
        )}
      </div>
    </div>
  );
}
